import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, Check, Loader2, Mail } from "lucide-react";
import { WhatsAppGlyph } from "@/components/cards/CardShell";
import { fetchReminder, markReminded, reminderMsg, sendReminder } from "@/lib/bf";
import { waLink } from "@/lib/wa";

const when = (iso) => new Date(iso).toLocaleString("ro-RO", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export default function BFReminder({ cfg }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { fetchReminder().then(setData).catch(() => {}); }, []);
  if (!data) return null;
  const rows = data.rows;
  const mark = (id) => markReminded(id).then(() => setData((d) => ({ ...d, rows: d.rows.map((r) => (r.id === id ? { ...r, reminded: true } : r)) }))).catch(() => toast.error("Nu am putut marca"));
  const send = () => {
    setBusy(true);
    sendReminder().then((r) => { toast.success(`Email trimis cu ${r.leads} saloane`); setData((d) => ({ ...d, manual_at: new Date().toISOString() })); })
      .catch(() => toast.error("Nu am putut trimite emailul")).finally(() => setBusy(false));
  };
  return (
    <section className="invite-box" data-testid="bfa-reminder">
      <div className="ins-head">
        <h3>Reamintire ultima zi · n-au comandat ({rows.length}) · {rows.filter((r) => r.reminded).length === 1 ? "1 trimisă" : `${rows.filter((r) => r.reminded).length} trimise`}</h3>
      </div>
      <div className="bfa-launch">
        <BellRing size={15} />
        <p data-testid="bfa-reminder-info">
          {data.sent_at ? `Notificarea a fost trimisă pe email la ${when(data.sent_at)}.` : `Pe ${cfg.end.split("-").reverse().join(".")} la 09:00 primești pe email lista saloanelor înscrise care n-au comandat, cu buton WhatsApp și mesaj de reamintire gata scris.`}
          {data.manual_at ? ` Ultima trimitere manuală: ${when(data.manual_at)}.` : ""}
        </p>
        <button type="button" className="st-btn st-btn--ghost" onClick={send} disabled={busy} data-testid="bfa-reminder-send">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Mail size={14} />} Trimite-mi lista acum
        </button>
      </div>
      <p className="st-hint">Fiecare salon primește un link personal, ca să știm dacă a intrat și a comandat. Apasă WhatsApp, apoi Trimite din telefon.</p>
      <ul className="bfa-leads">
        {rows.map((r) => (
          <li key={r.id} className={r.reminded ? "is-done" : ""} data-testid={`bfa-rem-${r.id}`}>
            <div><b>{r.salon}</b><span>{r.phone}{r.city ? ` · ${r.city}` : ""} · {r.visits ? `${r.visits} ${r.visits === 1 ? "vizită" : "vizite"}, ultima ${when(r.last_visit)}` : "nu a intrat"}</span></div>
            <div className="interested-actions">
              <a className="st-btn st-btn--ghost" href={waLink(r.phone, reminderMsg(cfg, r))} target="_blank" rel="noopener noreferrer" onClick={() => mark(r.id)} data-testid={`bfa-rem-wa-${r.id}`}><WhatsAppGlyph /> WhatsApp</a>
              {r.reminded ? <span className="bfa-lead-ok"><Check size={13} /> Trimis</span> : <button type="button" className="st-btn st-btn--light" onClick={() => mark(r.id)} data-testid={`bfa-rem-mark-${r.id}`}><Check size={13} /> Marchează trimis</button>}
            </div>
          </li>
        ))}
        {!rows.length && <li className="st-hint">Toate saloanele înscrise au comandat.</li>}
      </ul>
    </section>
  );
}
